var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-message-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("h1", { staticClass: "lbv-page-title" }, [
                  _vm._v("\n          Message List\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    staticClass:
                      "align-items-center secondary message-list-filters",
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Tenant",
                              "label-for": "tenant-id",
                            },
                          },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    staticClass: "full-width",
                                    attrs: { id: "tenant-id" },
                                    model: {
                                      value: _vm.selectedTenant,
                                      callback: function ($$v) {
                                        _vm.selectedTenant = $$v
                                      },
                                      expression: "selectedTenant",
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          "\n                    All\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.tenants, function (tenant) {
                                      return _c(
                                        "option",
                                        _vm._b(
                                          {
                                            key: tenant.id,
                                            domProps: { value: tenant.id },
                                            on: {
                                              option: function ($event) {
                                                return _vm.$emit(
                                                  "option",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          },
                                          "option",
                                          _vm.$attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(tenant.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Code", "label-for": "code" } },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    id: "code",
                                    options: _vm.emailCodes,
                                  },
                                  model: {
                                    value: _vm.selectedCode,
                                    callback: function ($$v) {
                                      _vm.selectedCode = $$v
                                    },
                                    expression: "selectedCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Type", "label-for": "type" } },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-select", {
                                  attrs: { id: "type", options: _vm.commType },
                                  model: {
                                    value: _vm.selectedType,
                                    callback: function ($$v) {
                                      _vm.selectedType = $$v
                                    },
                                    expression: "selectedType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Lang", "label-for": "lang" } },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-select", {
                                  attrs: { id: "lang", options: _vm.languages },
                                  model: {
                                    value: _vm.selectedLanguage,
                                    callback: function ($$v) {
                                      _vm.selectedLanguage = $$v
                                    },
                                    expression: "selectedLanguage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mb-3 d-flex", attrs: { md: "3" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "w-100 mr-3",
                            attrs: { id: "applyBtn", variant: "primary" },
                            on: { click: _vm.applyFilters },
                          },
                          [_vm._v("\n              Apply\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "w-100 mr-3",
                            attrs: { id: "exportButton", variant: "primary" },
                            on: { click: _vm.downloadExport },
                          },
                          [_vm._v("\n              Export\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "w-100",
                            attrs: { id: "addButton", variant: "primary" },
                            on: { click: _vm.addNew },
                          },
                          [_vm._v("\n              Add\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    striped: "",
                    hover: "",
                    responsive: "",
                    items: _vm.paginatedList,
                    fields: _vm.fields,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "emailCode",
                      fn: function (data) {
                        return [
                          _c(
                            "b-link",
                            {
                              staticClass: "deviceLink",
                              on: {
                                click: function ($event) {
                                  return _vm.showEmail(data)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(data.value) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.currentPage === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " +
                      _vm._s(_vm.currentPage) +
                      "\n        "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "emailView",
                attrs: {
                  id: "email-view",
                  title: "View Message",
                  "ok-variant": "primary",
                  "ok-title": "Update",
                  "ok-disabled": !_vm.hasUpdates,
                },
                on: { ok: _vm.save },
              },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Subject:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-input", {
                          staticClass: "col-md-10",
                          attrs: { type: "text" },
                          model: {
                            value: _vm.updatedSubject,
                            callback: function ($$v) {
                              _vm.updatedSubject = $$v
                            },
                            expression: "updatedSubject",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Body:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          staticClass: "col-md-10",
                          attrs: { rows: "10", "max-rows": "20" },
                          model: {
                            value: _vm.updatedBody,
                            callback: function ($$v) {
                              _vm.updatedBody = $$v
                            },
                            expression: "updatedBody",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { horizontal: "", label: "", "label-cols": 2 } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "col-md-2",
                            attrs: { size: "sm", variant: "secondary" },
                            on: { click: _vm.preview },
                          },
                          [_vm._v("\n              Preview\n            ")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Tokens:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-input", {
                          staticClass: "col-md-10",
                          attrs: { type: "text" },
                          model: {
                            value: _vm.updatedTokens,
                            callback: function ($$v) {
                              _vm.updatedTokens = $$v
                            },
                            expression: "updatedTokens",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "addNewView",
                attrs: {
                  id: "add-new",
                  title: "Add New Message",
                  "ok-variant": "primary",
                  "ok-title": "Save",
                },
                on: {
                  ok: _vm.save,
                  cancel: _vm.closeDialog,
                  hidden: _vm.closeDialog,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Tenant:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c(
                          "b-form-select",
                          {
                            staticClass: "full-width",
                            attrs: { id: "selectTenants" },
                            model: {
                              value: _vm.selectedTenant,
                              callback: function ($$v) {
                                _vm.selectedTenant = $$v
                              },
                              expression: "selectedTenant",
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v("\n                All\n              "),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tenants, function (tenant) {
                              return _c(
                                "option",
                                _vm._b(
                                  {
                                    key: tenant.id,
                                    domProps: { value: tenant.id },
                                    on: {
                                      option: function ($event) {
                                        return _vm.$emit(
                                          "option",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  },
                                  "option",
                                  _vm.$attrs,
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(tenant.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Type:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.commType },
                          model: {
                            value: _vm.selectedType,
                            callback: function ($$v) {
                              _vm.selectedType = $$v
                            },
                            expression: "selectedType",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Lang:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.languages },
                          model: {
                            value: _vm.selectedLanguage,
                            callback: function ($$v) {
                              _vm.selectedLanguage = $$v
                            },
                            expression: "selectedLanguage",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Code:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.emailCodes },
                          model: {
                            value: _vm.selectedCode,
                            callback: function ($$v) {
                              _vm.selectedCode = $$v
                            },
                            expression: "selectedCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Subject:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.updatedSubject,
                            callback: function ($$v) {
                              _vm.updatedSubject = $$v
                            },
                            expression: "updatedSubject",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "bodyInput",
                          horizontal: "",
                          label: "Body:",
                          "label-cols": 2,
                          "label-text-align": "top",
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: { rows: "8", "max-rows": "8" },
                          model: {
                            value: _vm.updatedBody,
                            callback: function ($$v) {
                              _vm.updatedBody = $$v
                            },
                            expression: "updatedBody",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { horizontal: "", label: "", "label-cols": 2 } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "col-md-3",
                            attrs: { size: "sm", variant: "secondary" },
                            on: { click: _vm.preview },
                          },
                          [_vm._v("\n              Preview\n            ")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          horizontal: "",
                          label: "Tokens:",
                          "label-cols": 2,
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.updatedTokens,
                            callback: function ($$v) {
                              _vm.updatedTokens = $$v
                            },
                            expression: "updatedTokens",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }